// This icon file is generated automatically.
var PVerticalAlignMiddlOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.44 6.4H1.56a.13.13 0 00-.12.13v.94c0 .07.05.12.12.12h10.88c.07 0 .12-.05.12-.12v-.94a.13.13 0 00-.12-.12zM6.9 5.25c.05.06.13.06.18 0l1.57-2a.11.11 0 00-.09-.18H7.6V.62A.13.13 0 007.47.5h-.94a.13.13 0 00-.12.13v2.43h-.99c-.09 0-.14.11-.08.19L6.9 5.24zm.18 3.52a.11.11 0 00-.18 0l-1.57 2c-.06.07 0 .18.09.18h.98v2.44c0 .06.05.12.12.12h.94c.07 0 .12-.06.12-.13v-2.43h.98c.1 0 .15-.11.1-.19L7.08 8.76z", "fill-rule": "nonzero" } }] }, "name": "p-vertical-align-middl", "theme": "outlined" };
export default PVerticalAlignMiddlOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PVerticalAlignMiddlOutlined.js
// module id = 3725
// module chunks = 0